import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Api from '@plone/volto/helpers/Api/Api';

import { SET_LIGHTSITE_SETTINGS } from '../../constants/ActionTypes';

const setLightsiteSettings = (settings) => ({
  type: SET_LIGHTSITE_SETTINGS,
  payload: settings,
});

const LightsiteSettings = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const api = new Api();
        const data = await api.get('/@lightsite-settings-data');
        dispatch(setLightsiteSettings(data));
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching registry:', error);
      }
    };
    fetchData();
  }, [dispatch]);

  return null;
};

export default LightsiteSettings;
